/***
 * Created on 2024/3/13
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import group_avatar_svg from '../../static/img/utils/ic-avatar-group.svg';
import user_avatar_svg from '../../static/img/utils/ic-avatar-default.svg';
import {useRegion} from "../../context/RegionContext";
import UserStatusComponent from "../common/UserStatusComponent";

const DeviceAdminContactItemComponent = ({contactType, contact, admin, onToggle}) => {
    const {url} = useRegion();
    const [noAvatar, setNoAvatar] = useState(false);

    const isQid = contactType === 'qid';
    const isEligible = isQid ? contact?.status === 'active' : true;

    const getUserId = (entry) => typeof entry === 'object' ? entry.id : entry;
    const getGroupId = (entry) => typeof entry === 'object' ? (entry.organization_group_id || entry.id) : entry;

    const checked = isQid
        ? !!admin?.organization_users?.find(entry => getUserId(entry) === contact.id)
        : !!admin?.organization_groups?.find(entry => getGroupId(entry) === contact.organization_group_id);

    const toggleAdmin = () => {
        if (!isEligible) return;
        if (isQid) {
            onToggle(prev => {
                const exists = prev?.organization_users?.find(entry => getUserId(entry) === contact.id);
                const new_users = exists
                    ? prev.organization_users.filter(entry => getUserId(entry) !== contact.id)
                    : [...(prev?.organization_users || []), contact.id];
                return {...prev, organization_users: new_users};
            });
        } else {
            onToggle(prev => {
                const exists = prev?.organization_groups?.find(entry => getGroupId(entry) === contact.organization_group_id);
                const new_groups = exists
                    ? prev.organization_groups.filter(entry => getGroupId(entry) !== contact.organization_group_id)
                    : [...(prev?.organization_groups || []), contact.organization_group_id];
                return {...prev, organization_groups: new_groups};
            });
        }
    };

    const rowId = isQid ? contact.id : contact.organization_group_id;

    return (
        <li className={`list-item list-item--cb ${checked ? 'selected' : ''}`}>
            <div className="contact-info">
                <div className="comp-checkbox no-label">
                    <input type="checkbox" id={rowId}
                           checked={checked}
                           disabled={!isEligible}
                           onChange={toggleAdmin}/>
                    <label htmlFor={rowId} className="comp-label"/>
                </div>
                <div className="account-img">
                    <div className={`avatar ${noAvatar ? 'no-avatar' : ''}`}>
                        {isQid && (
                            <>
                                {!noAvatar && <img src={`${url.get_acc_url()}/avatar/${contact.id}/i`} alt="" onError={() => setNoAvatar(true)}/>}
                                {noAvatar && contact?.display_name && <span>{contact.display_name[0]?.toUpperCase()}</span>}
                                {noAvatar && !contact?.display_name && <img src={user_avatar_svg} alt=""/>}
                            </>
                        )}
                        {!isQid && <img src={group_avatar_svg} alt=""/>}
                    </div>
                </div>
                <div className="account-info">
                    <div className="name">{isQid ? contact.display_name : contact.name}</div>
                    {isQid && <div className="mail">{contact.email}</div>}
                </div>
                {isQid && (
                    <div className="account-status">
                        <UserStatusComponent user={contact}/>
                    </div>
                )}
            </div>
        </li>
    );
};

export default DeviceAdminContactItemComponent;
